




































































































































import {Component, Prop, Vue} from 'vue-property-decorator';
import {PHeaterMonitorModule, PModuleMeasurementTableHeader} from '@v/system/modules/interfaces';
import TableCheckBox from '@c/tables/TableCheckBox.vue';
import PModuleMeasurementEditDialog from '@v/system/modules/forms/PModuleMeasurementEditDialog.vue';
import measurementsStoreModule from '@/store/modules/entities/measurementsModule';
import {PModuleMeasurementStore} from '@/views/system/modules/forms/pModuleMeasurementStore';
import IconButton from '@c/controls/IconButton.vue';
import CancelChangesDialog from '@c/CancelChangesDialog.vue';
import router from '@/router';
import PModuleButtons from './../../nodes/PModuleButtons.vue';
import nodeModule from '@/store/modules/entities/nodeModule';
import ModulesTable from './ModulesTable.vue';
import {updateMeasurements} from '../moduleUtils';

@Component({
  components: {
    TableCheckBox,
    PModuleMeasurementEditDialog,
    IconButton,
    CancelChangesDialog,
    PModuleButtons,
    ModulesTable,
  },
})
export default class HeaterMonitorModuleForm extends Vue {
  loading = false;
  saving = false;

  valid = true;

  showError = false;

  nodeName: any = null;

  @Prop({required: true})
  pmodule!: PHeaterMonitorModule;

  nonEmptyTextRule = (v: any) => !!v || (v && v.length === 0) || 'Поле обязательно для заполнения';

  nonEmptyNumberRule = (v: any) => v != null || 'Поле обязательно для заполнения';

  integerNumberRule = (v: any) => Number.isInteger(Number(v)) || 'Поле должно быть целым числом';

  showMaxMessageCount = false;
  showChilds = false;
  showErrorCode = false;

  showSettings = false;

  measurementDialog = PModuleMeasurementEditDialog;

  measurementsHeaders: PModuleMeasurementTableHeader[] = [
    {
      text: 'Измерение',
      value: 'measurementDescription',
      sortable: false,
    },
    {
      text: 'В. гр. предупреждения',
      value: 'topWarningBoundary',
      sortable: false,
    },
    {
      text: 'В. гр. опасного значения',
      value: 'topDangerBoundary',
      sortable: false,
    },
    {
      text: 'В. гр. ошибки',
      value: 'topErrorBoundary',
      sortable: false,
    },
    {
      text: 'Н. гр. предупреждения',
      value: 'bottomWarningBoundary',
      sortable: false,
    },
    {
      text: 'Н. гр. опасного значения',
      value: 'bottomDangerBoundary',
      sortable: false,
    },
    {
      text: 'Н. гр. ошибки',
      value: 'bottomErrorBoundary',
      sortable: false,
    },
  ];

  get measurementsStore() {
    return new PModuleMeasurementStore(this.pmodule, {
      'topWarningBoundary': true,
      'topDangerBoundary': true,
      'topErrorBoundary': true,
      'bottomWarningBoundary': true,
      'bottomDangerBoundary': true,
      'bottomErrorBoundary': true,
    });
  }

  async loadMeasurements() {
    // Подгружаем список измерений, ещё не использованных в таблице
    await measurementsStoreModule.fetchAll();
    if (this.pmodule.measurements) {
      const newEntities = measurementsStoreModule.entities.filter(
        (x: any) =>
          x.moduleType === this.pmodule.type &&
          !this.pmodule.measurements.some((y: any) => y.measurementId == x.id),
      );
      // если такие измерения найдены, добавляем их в таблицу измерений модуля
      if (newEntities.length > 0) {
        updateMeasurements(this.pmodule.measurements, newEntities);
      }
    }
  }

  nodeFieldClick() {
    router.push(`/nodes/${this.pmodule.nodes ? this.pmodule.nodes[0].node_id : 0}`); //TODO: fix it?
  }

  async created() {
    //для тех измерений, которые уже сохранены, проставляем isActive = true и isNew = false
    this.pmodule.measurements.forEach((elem: any) => {
      if (!elem.isNew) {
        elem.isActive = true;
        elem.isNew = false;
      }
    });
    await this.loadMeasurements();
    if (this.pmodule.nodes && this.pmodule.nodes.length > 0) {
      const {data} = await nodeModule.edit(this.pmodule.nodes[0].node_id); //TODO: fix it?
      this.nodeName = data.name;
    }
    this.canShowSettings(this.pmodule);
  }

  canShowSettings(pmodule: PHeaterMonitorModule) {
    if (pmodule.maxMessageCount == 0) this.showSettings = false;
    else this.showSettings = true;
  }

  async onSave() {
    this.pmodule.measurements = this.pmodule.measurements.filter((x: any) => x.isActive === true);

    this.valid = await (this.$refs.form as any).validate();

    if (!this.valid) {
      const error = document.querySelector('div.error--text');
      error && (await this.$vuetify.goTo(error as HTMLElement));
      return;
    }

    this.$emit('save');
  }

  //переменная, сигнализирующая о внесенных и несохраненных изменениях на форме
  changed = false;

  // Действия при изменении поля
  async onChange() {
    this.changed = true;
  }

  get cancelChangesDialog() {
    return this.$refs.cancelChangesDialog as any;
  }

  back() {
    // если были внесены изменения на форме
    if (this.changed) {
      this.cancelChangesDialog.open('/modules');
    } else router.push('/modules');
  }
}
